import { defineStore } from "pinia";
import useCategoriesGetters from "@/stores/categories/getters.ts";
import useCategoriesActions from "@/stores/categories/actions.ts";

export const useCategoriesStore = defineStore("categories-store", () => {
  const getters = useCategoriesGetters();
  const actions = useCategoriesActions();
  return { ...getters, ...actions };
});
